import React from 'react';
import { Button } from 'antd';
import { CopyOutlined, EditOutlined } from '@ant-design/icons';

import DeleteButton from '../../common/DeleteButton';

const CompoundSideActionButtons = ({
  item,
  onUpdate,
  onDelete,
  onDuplicate,
  children,
  additionalStyle,
}) => (
  <div style={{ ...additionalStyle, height: 42, display: 'flex', alignItems: 'center' }}>
    <Button
      icon={<EditOutlined />}
      className="square-icon-button"
      style={{ border: '1px solid transparent', backgroundColor: 'transparent' }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onUpdate(item);
      }}
    />
    <Button
      icon={<CopyOutlined />}
      className="square-icon-button"
      style={{ border: '1px solid transparent', backgroundColor: 'transparent' }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDuplicate(item);
      }}
    />
    {children}
    <DeleteButton onDelete={() => onDelete(item)}>
      <div>
        Are you sure to permanently delete <span style={{ fontWeight: 'bold' }}>{item.name}</span>?
      </div>
    </DeleteButton>
  </div>
);

export default CompoundSideActionButtons;
